import { render, staticRenderFns } from "./BirthdayAdd.vue?vue&type=template&id=d7bdf5c4&scoped=true&"
import script from "./BirthdayAdd.vue?vue&type=script&lang=js&"
export * from "./BirthdayAdd.vue?vue&type=script&lang=js&"
import style0 from "./BirthdayAdd.vue?vue&type=style&index=0&id=d7bdf5c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7bdf5c4",
  null
  
)

export default component.exports